var _excluded = ["initialExpand", "node", "useMeta", "useSignal"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import _ from 'lodash';
import useCallDetectorInhibitor from "../../hooks/useCallDetectorInhibitor";

// eslint-disable-next-line func-names
import { jsx as _jsx } from "react/jsx-runtime";
var Expandable = function Expandable(Component) {
  return function (_ref) {
    var _ref$initialExpand = _ref.initialExpand,
      initialExpand = _ref$initialExpand === void 0 ? false : _ref$initialExpand,
      node = _ref.node,
      useMeta = _ref.useMeta,
      useSignal = _ref.useSignal,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useMeta = useMeta('isExpanded', initialExpand),
      isExpanded = _useMeta[0],
      setIsExpand = _useMeta[1];
    var initialIsVisible = React.useMemo(function () {
      return node.isRoot() ? true : node.parent.propagateToParent(function (node, last) {
        return last && node.meta.isExpanded;
      }, true);
    }, []);
    var _useMeta2 = useMeta('isVisible', initialIsVisible),
      isVisible = _useMeta2[0];
    var updateChildVisibility = React.useCallback(_.debounce(function () {
      node.propagateToChildren(function (node) {
        var isVisible = node.isRoot() ? true : node.parent.propagateToParent(function (node, last) {
          return last && node.meta.isExpanded;
        }, true);
        node.setMeta('isVisible', isVisible);
      });
    }, 0), [node]);
    var expand = React.useCallback(function () {
      setIsExpand(true);
      updateChildVisibility();
    }, [setIsExpand, updateChildVisibility]);
    var contract = React.useCallback(function () {
      setIsExpand(false);
      updateChildVisibility();
    }, [setIsExpand, updateChildVisibility]);
    var switchState = React.useCallback(function () {
      setIsExpand(!isExpanded);
      updateChildVisibility();
    }, [setIsExpand, isExpanded, updateChildVisibility]);
    var _useCallDetectorInhib = useCallDetectorInhibitor(switchState),
      getSwitchExpand = _useCallDetectorInhib[0],
      controlledSwitchState = _useCallDetectorInhib[1];
    useSignal('expand', expand);
    useSignal('contract', contract);
    useSignal('parentAdded', updateChildVisibility);
    var props = Object.assign({}, rest, {
      node: node,
      isExpanded: isExpanded,
      isVisible: isVisible,
      isExpandable: true,
      useMeta: useMeta,
      useSignal: useSignal,
      getSwitchExpand: getSwitchExpand
    });
    return /*#__PURE__*/_jsx("div", {
      style: {
        display: isVisible ? 'block' : 'none'
      },
      onClick: controlledSwitchState,
      children: /*#__PURE__*/React.createElement(Component, props)
    });
  };
};
Expandable.handledProps = [];
export default Expandable;